module.exports = __webpack_public_path__ + "assets/img/3.c016e060.png";